<template>
  <div class="bgc-gradient" style="padding-bottom: 1.2rem">
    <Header :is-nav="true" :title="headerTitles"></Header>
    <div class="main">
      <div class="message-list">
        <van-tabs @click="switchTab">
          <van-tab v-for="item in menuList" :key="item.type" :name="item.type">
            <div slot="title">{{ item.name }}</div>
          </van-tab>
        </van-tabs>
        <div class="message-scroll">
          <van-pull-refresh v-model="loading" @refresh="onRefresh">
            <van-list v-if="messageList.length > 0" v-model="loading" :finished="finished" finished-text="没有更多了" @load="load">
              <MessageContent v-if="messageList && messageList.length" :headerTitle="headerTitle"
                              :messageList="messageList"></MessageContent>
            </van-list>
            <van-empty v-else class="custom-empty" description="暂无数据"></van-empty>
          </van-pull-refresh>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import MessageContent from "./components/Content";
import commonApi from "@/request/commonApi.js";
import contentApi from "@/request/contentApi";

export default {
  name: "MessageList",
  components: {
    Header,
    MessageContent,
  },
  data() {
    return {
      loading: false,
      finished: false,
      headerTitle: "全部",
      headerTitles: "商情资讯",
      infoType: "", //默认 全部，
      menuList: [
        {
          name: "全部",
          type: "",
        },
        {
          name: "新闻资讯",
          type: "10",
        },
        {
          name: "行业政策",
          type: "20",
        },
        {
          name: "行情热点",
          type: "30",
        }
      ],
      hasNextPage: true,
      infoTypeList: [],
      messageList: [],
      formPage: {
        currentPage: 0,
        pageSize: 10,
      }, //默认显示10条数据，没下拉一次更新3条数据
    };
  },
  watch: {
    infoType: function () {
      this.formPage.currentPage = 0;
      this.formPage.pageSize = 10;
      this.messageList = [];
      this.getMessageList();
    },
  },
  created() {
    this.getInfoTypeSet();
    this.getMessageList();
  },
  methods: {
    switchTab(type) {
      this.changeType(type);
      let tempItem = this.menuList.find(item => {
        return item.type == type;
      });
      this.headerTitle = tempItem.name;
    },
    changeType(type) {
      this.infoType = type;
    },
    load() {
      this.getMessageList()
    },
    onSearch(val) {
      this.searchForm.keyword = val;
      this.finished = false;
      this.getMessageList();
    },
    onRefresh() {
      this.finished = false;
      this.getMessageList(true);
    },
    getMessageList(refresh) {
      if (refresh) {
        this.orderList = [];
        this.formPage.currentPage = 1
      } else {
        this.formPage.currentPage = this.formPage.currentPage + 1
      }
      let params = Object.assign(
          {},
          {infoType: this.infoType},
          this.formPage
      );
      this.loading = true
      contentApi.listInfoPageTwo(params).then((res) => {
        if (res.returnCode == "0") {
          refresh
              ? (this.messageList = res.result.dataList)
              : (this.messageList = [...this.messageList, ...res.result.dataList]);
          this.hasNextPage = res.result.hasNextPage;
          if (!this.hasNextPage) {
            this.finished = true;
          }
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      }).finally(() => {
        this.loading = false
      });
    },
    getInfoTypeSet() {
      let params = {
        setCode: "LNG_INFO_TYPE",
      };
      commonApi.listCodeSet(params).then((res) => {
        if (res.returnCode === "0") {
          this.infoTypeList = res.result;
          console.log("infoTypeList", this.infoTypeList);
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
  },
};
</script>

<style lang='stylus' scoped>
.main {
  flex: 1;
  height: 85vh;
  overflow: hidden;
  top: 0.88rem;
  left: 0;
  right: 0;

  /deep/ .van-tabs__line {
    left: 10px;
  }

  /deep/ .van-tabs__nav {
    background: none;
  }

  /deep/ .van-tab--active {
    background: none;
    color: rgba(0, 0, 0, 1) !important;
    font-size: 36px !important;
    font-weight: 600;
  }

  /deep/ .van-tab {
    color: rgba(143, 143, 143, 1);
    font-size: 16px;
    flex: none;
    margin-left: 0.45rem;
  }

  /deep/ .van-tabs__nav :nth-child(1) {
    margin-left: 0.1rem !important;
  }
}

.message-list {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin: 0;
  // background: #eeeeee;
  font-size: 28px;

  .message-scroll {
    flex: 1;
    overflow: auto;
    padding: 20px 24px 0 24px;
  }
}

.message-list >>> .van-tab {
  font-size: 32px;
  line-height: 50px;
}

.message-list >>> .van-tabs__content {
  padding: 0 24px;
}

.message-list >>> .van-tabs__wrap {
  height: 70px;
  line-height: 70px;
}

.message-list >>> .van-tabs__nav--line {
  padding-bottom: 8px;
}

.message-list >>> .van-tabs__nav {
  background: none;
}
</style>
